import { render } from "./fawry-info.vue?vue&type=template&id=26354f01&scoped=true"
import script from "./fawry-info.vue?vue&type=script&lang=js"
export * from "./fawry-info.vue?vue&type=script&lang=js"

import "./fawry-info.vue?vue&type=style&index=0&id=26354f01&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26354f01"]])

export default __exports__